import {Injectable, Injector} from "@angular/core";
import {ExtraData} from "./extra.data";
import {EntityModel} from "@fedeltapointofsale/data-client";

/**
 * this is used for add, edit and delete actions for extras
 */
@Injectable()
export class ExtraEntityModel extends EntityModel<ExtraData> {

    constructor(injector: Injector) {
        super(injector, ExtraData);
    }
}
